<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <vue-headful :title="getTitleSeo()" :description="getDescSeo()" :keywords="getKeywordsSeo()" />

    <Banner :background="info.image ? info.image.url : ''" :title="!pgLoading ? $t('app.projects') : ''"
      :subtitle="!pgLoading ? info.name : ''">
    </Banner>

    <section class="course-area course-area-02 pt-50 pb-50">
      <div class="container">
        <!-- <div class="row">
          <div class="col d-flex orphans-nav mb-3" style="padding: 0">
            <div v-if="!pgLoading" class="col-md-3 select-area m-1">
              <select
                class="form-control"
                style="height: 50px; width: 100%"
                v-model="country_id"
                @change="onCountry()"
              >
                <option value="">-- {{ $t("app.choose_country") }} --</option>
                <option
                  v-for="(con, idx) in countries"
                  :key="idx"
                  :value="con.id"
                >
                  {{ con.name }}
                </option>
              </select>
            </div>
            <div v-if="pgLoading" class="col-md-3 select-area m-1">
              <div class="webkit-animation webkit-100per-46"></div>
            </div>

            <div
              v-if="!pgLoading && country_id != ''"
              class="col-md-3 select-area m-1"
            >
              <select
                class="form-control"
                style="height: 50px"
                v-model="city_id"
                @change="onCities()"
              >
                <option value="">-- {{ $t("app.choose_city") }} --</option>
                <option
                  v-for="(city, idx) in cities"
                  :key="idx"
                  :value="city.id"
                >
                  {{ city.name }}
                </option>
              </select>
            </div>
            <div v-if="pgLoading" class="col-md-3 select-area m-1">
              <div class="webkit-animation webkit-100per-46"></div>
            </div>

            <div v-if="!pgLoading" class="col-md-3 input-area m-1">
              <form @submit="fetchData(false)">
                <input
                  type="text"
                  class="form-control"
                  v-model="search"
                  :placeholder="$t('app.search_via_name')"
                />
              </form>
            </div>
            <div v-if="pgLoading" class="col-md-3 input-area m-1">
              <div class="webkit-animation webkit-100per-46"></div>
            </div>

            <div :class="country_id ? 'col-md-2' : 'col-md-5'"></div>
            <div
              v-if="!pgLoading"
              class="col-md-1 select-area m-1 justify-self-end"
            >
              <select
                v-model="paginate.itemsPerPage"
                @change="fetchData(false)"
                :style="
                  $i18n.locale == 'ar'
                    ? 'margin-left:12px !important'
                    : 'margin-left:-6px !important'
                "
              >
                <option value="">{{ $t("app.appear") }}</option>
                <option value="24">24</option>
                <option value="48">48</option>
                <option value="98">98</option>
              </select>
            </div>
            <div v-if="pgLoading" class="col-md-1 input-area m-1">
              <div class="webkit-animation webkit-100per-46"></div>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div v-for="(row, idx) in rows" :key="idx" class="col-xl-4 col-lg-4 col-md-6">
            <div class="cases mb-30 wow fadeInUp2 animated" data-wow-delay=".3s">
              <div class="cases__box pos-rel">
                <div class="cases__box--img">
                  <router-link :to="{
                    name: 'show-country-projects',
                    params: {
                      cat: row.category.slug,
                      country_id: row.country.id,
                    },
                  }">
                    <img :src="row.image
                        ? row.image.url
                        : '/assets/img/logo/min-logo.png'
                      " loading="lazy" :alt="row.title" class="img-box-500" />
                  </router-link>
                </div>
                <ul class="cases__tag white-bg">
                  <li>
                    <div class="cases--author d-flex align-items-center">
                      <!--  <img src="/assets/img/flags/egypt-flag.png" alt="" /> -->
                      <flag v-if="row.country" :iso="row.country.ccode" style="font-size: 35px; border-radius: 50%" />
                      <div>
                        <h4 class="semi-02-title ml-15">
                          {{ row.country ? row.country.name : "" }}
                        </h4>
                        <span style="font-size: 12px">{{
                          row.main_category ? row.main_category.name : ""
                        }}</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <a class="theme_btn theme_btn_bg d-btn case-card-target" href="javascript:;">
                      <div>{{ $t("app.nominationValue") }}</div>
                      <div>{{ row.target }} {{ $t("app.dinar") }}</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <Pagination v-if="!pgLoading" :currentPage="paginate.currentPage" :itemsPerPage="paginate.itemsPerPage"
          :resultCount="paginate.resultCount" :nextPage="paginate.nextPage" :prevPage="paginate.prevPage"
          v-on:pageChange="handlePageChange">
        </Pagination>
        <!-- End Pagination -->
      </div>
    </section>
  </div>
</template>

<script>
import sendEvent from "@/helpers/sendEvent";
import { trackAddToCart } from "@/helpers/pixel";
import iziToast from "izitoast";

export default {
  name: "List",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    Pagination: () => import("@/components/Pagination.vue"),
  },
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      items: [],
      refs: "projects",

      locale: "ar",
      pgLoading: true,
      info: "",
      countries: [],
      categories: [],
      rows: [],
      search: "",

      country_id: "",
      category_id: "",
      category_slug: "",

      city_id: "",
      cityLoading: false,
      cities: [],

      paginate: {
        currentPage: 1,
        itemsPerPage: 24,
        resultCount: 0,
        nextPage: 2,
        prevPage: 0,
      },

      whatsAppNo: window.whatsAppNo,
      paymentStatus: 1,
    };
  },
  mounted() { },
  watch: {
    $route() {
      if (this.$route.params.slug) {
        this.category_slug = this.$route.params.slug;
      }
      if (this.$route.params.country_id) {
        this.country_id = this.$route.params.country_id;
      }
      this.fetchData();
    },
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (this.$route.params.slug) {
      this.category_slug = this.$route.params.slug;
    }
    if (this.$route.params.country_id) {
      this.country_id = this.$route.params.country_id;
    }

    this.fetchData();
    this.fetchPayment();
  },
  methods: {
    getTitleSeo() {
      let lang = this.$i18n.locale;
      let meta = this.info.meta;
      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_title
          : meta.en.meta_title
        : "country";
      return data;
    },
    getDescSeo() {
      let lang = this.$i18n.locale;
      let meta = this.info.meta;

      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_description
          : meta.en.meta_description
        : "meta_description";
      return data;
    },
    getKeywordsSeo() {
      let lang = this.$i18n.locale;
      let meta = this.info.meta;

      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_keywords
          : meta.en.meta_keywords
        : "meta_keywords";
      return data;
    },

    fetchPayment() {
      const options = {
        url: window.baseURL + "/settings/26",
        method: "GET",
      };

      this.$axios(options)
        .then((res) => {
          this.paymentStatus = res.data.status;
        })
        .catch(() => {
          this.paymentStatus = 0;
        })
        .finally(() => { });
    },
    //
    fetchData(scrolTop = true) {
      if (scrolTop) {
        window.scrollTo(0, 0);
      }
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/categories/" + this.$route.params.cat,
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          country_id: this.country_id,
          city_id: this.city_id,
          search: this.$route.query.q,
          status: "active",
          paginate: this.paginate.itemsPerPage,
          page: this.paginate.currentPage,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          //this.rows = res.data.srows;
          this.rows = res.data.proCountries;
          this.countries = res.data.countries;
          this.categories = res.data.categories;

          // info
          this.info = res.data.info;
          this.category_id = res.data.info.id;

          // paginate
          this.paginate.currentPage = res.data.paginate.current_page;
          this.paginate.resultCount = res.data.paginate.total;
          this.paginate.nextPage = res.data.paginate.next_page;
          this.paginate.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => { })
        .finally(() => { });
    },

    onCountry: function () {
      this.fetchCities();
      this.city_id = "";
      this.fetchData(false);
    },
    onCities: function () {
      this.fetchData(false);
    },

    onCategory: function () {
      this.$router.push({
        name: "show-categories",
        params: { slug: this.category_slug },
      });
    },

    fetchCities() {
      this.cityLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/cities",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          country_id: this.country_id,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.cityLoading = false;
          this.cities = res.data.rows;
        })
        .catch(() => { })
        .finally(() => { });
    },

    handlePageChange(event) {
      this.paginate.currentPage = event.currentPage;
      this.fetchData();
    },

    addToCart(proid, donation = false) {
      // paymentStatus
      if (this.paymentStatus == 0) {
        iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.payment_status_error"),
        });
        return false;
      }

      if (!this.auth.access_token) {
        this.$router.push({ name: "login" });
      } else if (donation) {
        iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.donate_before_msg"),
        });
      } else {
        this.showLoading(proid);
        this.axios.defaults.headers.common = {
          "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
          Authorization: `Bearer ` + this.auth.access_token,
        };
        const options = {
          url: window.baseURL + "/carts",
          method: "POST",
          data: {
            model_id: proid,
            model_type: "projects",
          },
          params: {},
        };
        this.$axios(options)
          .then(() => {
            sendEvent("AddToCart");
            trackAddToCart({
              currency: "KWD",
              content_ids: [proid],
              content_type: "projects",
            });
            this.successLoading(proid);
            iziToast.success({
              icon: "ti-check",
              title: "",
              message: "this.$t('app.add_msg')",
            });
          })
          .catch((err) => {
            this.hideLoading(proid);
            if (err.response && err.response.status == 401) {
              this.removeLocalStorage();
              this.$router.push({ name: "login" });
            } else {
              iziToast.warning({
                icon: "ti-alert",
                title: "",
                message: err.response ? this.$t("app.add_fail") : "" + err,
              });
            }
          })
          .finally(() => { });
      }
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    showLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.add("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.remove("hidden");
    },

    hideLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.remove("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.add("hidden");
    },

    successLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.add("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.add("hidden");

      let success = document.querySelectorAll("a#btnSuccess_" + proid);
      let app3 = success[success.length - 1];
      app3.classList.remove("hidden");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
